import { ReactElement } from 'react';
import * as React from 'react';
import styles from './popin.module.scss';
import { useTranslation } from 'next-i18next';
import { IconEnum } from '@utmb/types/enum/IconEnum';
import { getColorStyle } from '@utmb/utils/colors';
import { ColorTypesEnum } from '@utmb/types/colors';
import { Icon } from '../icons/Icon';

interface PopinProps {
    children: React.ReactNode;
    closeCallback: () => void;
    isGrey?: boolean;
}

export const Popin = ({ children, closeCallback, isGrey }: PopinProps): ReactElement | null => {
    const { t } = useTranslation();

    return (
        <div className={styles.popin}>
            <div className={styles.container + ' ' + (isGrey ? styles.grey : '')}>
                <button className={styles.cross} onClick={() => closeCallback()}>
                    <Icon variant={IconEnum.CLOSE} color={getColorStyle(ColorTypesEnum.PRIMARY)} width={20} height={20} />
                </button>
                {children}
            </div>
        </div>
    );
};
